import { render, staticRenderFns } from "./publicHeader.vue?vue&type=template&id=640c5ef8&scoped=true&"
import script from "./publicHeader.vue?vue&type=script&lang=js&"
export * from "./publicHeader.vue?vue&type=script&lang=js&"
import style0 from "./publicHeader.vue?vue&type=style&index=0&id=640c5ef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640c5ef8",
  null
  
)

export default component.exports